module.exports = __webpack_public_path__ + "static/media/placeholder_project.c40fdcb4.jpg";